export default __webpack_public_path__ + "static/hero-energie-si-clima-ec56924c51c99d142f4d8f7246301606.jpg";